import styled from 'styled-components';

import { ArrowDirectionButton } from '../../../../components/inputs/buttons/ArrowDirectionButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.l}rem;
  width: 100%;
  padding: ${({ theme }) => theme.spaces.xxl}rem;
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila según Figma */
  border-radius: 1rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spaces.xl}rem;
  }
`;

export const ArrowRadioGroup = styled(ArrowDirectionButton)``;
